<div #map style="height: 100%; width: 100%" leaflet [leafletOptions]="options" [leafletLayers]="markers"
  (leafletMapReady)="onMapReady($event)">
</div>